import * as Yup from 'yup'

export const registerFormValidation = Yup.object({
  email: Yup.string().email("Email inválido").required("Campo obrigatório"),
  password: Yup.string()
    .test(
      'string compare',
      'NO_MORE_THAN_3_REPEATED_NUMBERS_IN_ORDER',
      function (password = '') {
        for (let i = 0; i <= 9; i++) {
          if (password.includes(`${i}${i}${i}${i}`)) {
            return false
          }
        }
        return true
      },
    )
    .test(
      'string compare',
      'THE_PASSWORD_CANNOT_HAVE_MORE_THAN_3_SEQUENTIAL_NUMBERS',
      (password = '') => {
        let sequentialCount = 1
        for (let i = 0; i < password.length - 1; i++) {
          const currentChar = password[i]
          const nextChar = password[i + 1]
          if (isNaN(currentChar) || isNaN(nextChar)) {
            sequentialCount = 1
          } else if (
            parseInt(currentChar) + 1 ===
            parseInt(nextChar)
          ) {
            sequentialCount++
            if (sequentialCount > 3) {
              return false
            }
          } else {
            sequentialCount = 1
          }
        }
        return true
      },
    )
    .test(
      'string compare',
      'THE_ENTERED_PASSWORD_DOES_NOT_COMPLY_WITH_THE_DEFINED_POLICIES',
      function (password = '') {
        if (password) {
          const numberMatches = password.match(/\d+/g) //eslint-disable-line
          const specialCharacters =
            /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/ //eslint-disable-line
          const specialCharactersMatches =
            specialCharacters.test(password) //eslint-disable-line

          if (!numberMatches || !specialCharactersMatches)
            return false
        }
        return true
      },
    )
    .test(
      'string compare',
      'THE_PASSWORD_MUST_CONTAIN_AT_LEAST_1_LETTER',
      function (password = '') {
        if (password) {
          const letterMatches = password.match(/[a-zA-Z]+/g) //eslint-disable-line
          if (!letterMatches) return false
        }
        return true
      },
    )

    .required("Obrigatório")
    .min(8, 'MINIMUM_PASSWORD_LENGTH')
    .max(20, 'MAXIMUM_PASSWORD_LENGTH'),
  confirmPassword: Yup.string()
    .max(20, 'MAXIMUM_PASSWORD_LENGTH')
    .required("Obrigatório")
    .typeError("Obrigatório")
    .oneOf(
      [Yup.ref('password'), null],
      'CONFIRM_FIELD_OTHER_THAN_PASSWORD',
    ),
  useTerms: Yup.boolean().oneOf([true], "Obrigatório"),
  useRegulation: Yup.boolean().oneOf([true], "Obrigatório"),
  usePrivacyPolicy: Yup.boolean().oneOf([true], "Obrigatório"),
  newsletter: Yup.boolean().notRequired(),
  isPreRegistration: Yup.boolean(),
  isStateDisabled: Yup.boolean(),
})
